import { render, staticRenderFns } from "./_QuoteOverviewSupplierBlock.vue?vue&type=template&id=bb91d9c6"
import script from "./_QuoteOverviewSupplierBlock.vue?vue&type=script&lang=js"
export * from "./_QuoteOverviewSupplierBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports